/**
 * 樂觀新增的臨時項目（id 為 temp-…，API 成功後換成真實資料）
 * 送出到完成之間半透明、不能點：點名稱會進到不存在的頁面，編輯／刪除也會打到不存在的 id
 */
export const pendingRowClass = (item: { id: string }) =>
  item.id.startsWith('temp-') ? 'opacity-60 pointer-events-none' : '';

/** 樂觀新增失敗時把臨時項目從列表 store（createEntityStore）移除 */
export const removeListItem = (
  storeBase: { setState: (fn: (state: any) => any) => void },
  id: string
) => {
  storeBase.setState((state: any) => ({
    items: state.items.filter((item: { id: string }) => item.id !== id),
    pagination: state.pagination ? { ...state.pagination, totalItems: Math.max(0, state.pagination.totalItems - 1) } : null,
    lastOptimisticUpdate: Date.now(),
  }));
};
